module.exports = __webpack_public_path__ + "static/media/icon-arrow-green-up.5c09f7bd.svg";